module.exports = __webpack_public_path__ + "frontend/images/agents/provide-appliances-xs-c019402c310cb3913e66a96a18dcd289.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/provide-appliances-xs.png
// module id = 362
// module chunks = 2